<div class="page-container">
    <div class="container">
        <div class="row">
            <div class="col-md-12 pt-5">
                <h2>
                    {{ 'central-login.account.settings.your.account' | translate }}
                </h2>
                <div class="row mt-5">
                    <div class="col-md-3">
                        <central-login-account-settings-navigation [page]="'preferences'"></central-login-account-settings-navigation>
                    </div>
                    <div class="col-md-9" *ngIf="currentUser">
                        <div class="row">
                            <div class="col-md-12">
                                <form [formGroup]="preferencesForm" (ngSubmit)="savePreferences()">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h3 class="mt-0 mb-4">{{ 'central-login.account.settings.account.preferences' | translate }}</h3>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group col-md-6">
                                                <label for="language" class="form-control-label"><h4>{{ 'central-login.account.settings.preferences.language' | translate }}</h4>
                                                    <ng-select class="psd" [items]="languageOptions" id="language" required bindValue="id" bindLabel="text" name="'language'" formControlName="language">
                                                    </ng-select>
                                                </label>
                                                <div *ngIf="submitted && _languageForm.language.errors">
                                                    <div class="alert alert-danger mt-3 p-2" *ngIf="_languageForm.language.errors.required">
                                                        {{ 'central-login.account.settings.preferences.language.required' | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="col-md-6">
                                                <button type="submit" class="btn psd-variant w-100" [disabled]="submitting">{{ 'central-login.account.settings.preferences.save' | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
